
import { Expose, Type } from "class-transformer";

export class VegetationIndexAverage {
  @Type(() => Date)
  @Expose({ name: 'scene_date' })
  public sceneDate!: Date;

  public average!: number;

  @Expose({ name: 'crop_count' })
  public cropCount!: number;

  @Expose({ name: 'area_sum' })
  public areaSum!: number;
}

export class VegetationIndexCrop {
  public index!: string;
  public noise!: number;
  public satellite!: string;

  @Type(() => Date)
  @Expose({ name: 'scene_date' })
  public sceneDate!: Date;

  public value!: number;
}
